export const Product = {
  VehicleInsurance: 1,
  PropertyInsurance: 2,
  VehicleLeasingInsurance: 3,
  TravelInsurance: 4,
  FleetInsurance: 5,
  LiabilityInsurance: 6
}

export type Product = typeof Product[keyof typeof Product]

/**
 * [Product, Product full name, Product short name, Product name]
 */
export const Products: [Product, string, string, string][] = [
  [Product.VehicleInsurance, 'Pojištění motorových vozidel', 'Vozidla', 'Pojištění vozidla'],
  [Product.PropertyInsurance, 'Pojištění majetku a odpovědnosti', 'Majetek', 'Pojištění nemovitosti'],
  [Product.VehicleLeasingInsurance, 'Pojištění motorových vozidel - leasing', 'Leasing', 'Leasing'],
  [Product.TravelInsurance, 'Cestovní pojištění', 'Cestovko', 'Cestovní pojištění'],
  [Product.FleetInsurance, 'Pojištění flotil', 'Fleet', 'Pojištění flotil'],
  [Product.LiabilityInsurance, 'Pojištění odpovědnosti', 'Odpovědnost', 'Pojištění odpovědnosti'],
]

export const getProductFullName = (type: Product | undefined) => {
  return type !== undefined ? Products.find(([key]) => key === type)?.[1] : undefined
}

export const getProductShortName = (type: Product | undefined) => {
  return type !== undefined ? Products.find(([key]) => key === type)?.[2] : undefined
}

export const getProductName = (type: Product | undefined) => {
  return type !== undefined ? Products.find(([key]) => key === type)?.[3] : undefined
}
